/**
 * Textos do acesso controlado (E145.F2, GUS-181, ADR-0099): a página aberta pelo QR de uma versão
 * emitida, o painel da equipe que gera e revoga o link, e o estado de acesso recusado do portal.
 * A recusa nunca diz o que o conteúdo guarda nem se o link existiu.
 */
export const ptBRAcesso = {
  publico: {
    eyebrow: 'Acesso pelo QR',
    titulo: 'Laudo emitido',
    intro:
      'Este link abre a versão emitida do laudo. A consulta não precisa de conta e não dá acesso ao resto do caso.',
    carregando: 'Conferindo o acesso…',
    versao: 'Versão {versao} · emitida em {data}',
    codigo: 'Código registrado',
    codigoExplica:
      'O arquivo baixado tem este código. Compare-o com o código do arquivo que você recebeu.',
    baixar: {
      laudo: 'Baixar laudo',
      resumo: 'Baixar resumo',
      evidencias: 'Baixar evidências',
      riscos: 'Baixar orientações',
    },
    baixando: 'Baixando…',
    baixado: 'Arquivo baixado. Código: {codigo}',
    semSaida: 'Esta versão não tem arquivo liberado para consulta por este link.',
    recusaTitulo: 'Este acesso não está disponível',
    recusa:
      'O link pode estar incompleto, ter sido substituído ou cancelado. Peça um novo link a quem enviou o laudo.',
    erroRede: 'Não foi possível falar com o servidor. Tente de novo em instantes.',
    muitasTentativas: 'Muitas tentativas seguidas. Aguarde alguns minutos e tente de novo.',
    tentarDeNovo: 'Tentar de novo',
  },
  equipe: {
    titulo: 'Acesso pelo QR',
    explica:
      'Gere um link para esta versão. Quem tiver o link abre só o laudo desta versão, sem entrar na plataforma. As orientações reservadas e os rascunhos nunca saem por ele.',
    gerar: 'Gerar link de acesso',
    gerando: 'Gerando…',
    gerado: 'Link gerado. Copie agora: ele não será mostrado de novo.',
    copiar: 'Copiar link',
    copiado: 'Link copiado.',
    copiaFalhou: 'Não foi possível copiar. Selecione o link acima e copie manualmente.',
    rotuloDoLink: 'Link de acesso desta versão',
    ativos: 'Links desta versão',
    nenhum: 'Nenhum link gerado para esta versão.',
    criadoEm: 'Gerado em {data}',
    revogadoEm: 'Cancelado em {data}',
    revogar: 'Cancelar link',
    revogando: 'Cancelando…',
    erro: 'Não foi possível concluir agora. Tente de novo.',
    semSaida: 'Esta versão não tem arquivo que possa ser entregue por link.',
  },
  recusado: {
    eyebrow: 'Cliente',
    titulo: 'Este conteúdo exige acesso autorizado',
    explica:
      'Entre com uma conta que tenha vínculo com este caso. Após o login, a plataforma verifica o acesso a este caso e às orientações internas.',
    limite:
      'Um link copiado não concede permissão. O QR do laudo não abre o caso nem as orientações internas.',
    entrar: 'Entrar na plataforma',
    voltar: 'Voltar aos seus casos',
  },
} as const;
